module.exports = __webpack_public_path__ + "img/9788954439923.ef5af684.jpg";